import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, actions } from 'builder/modules/careerProfile'
import { FetchStatuses } from 'builder/modules/constants'
import { useIsCareerProfileAvailable } from './useIsCareerProfileAvailable'

export const useCareerInsightsData = (isForceDisabled?: boolean) => {
  const dispatch = useDispatch()
  const isAvailable = useIsCareerProfileAvailable()
  const shouldInit = isAvailable && !isForceDisabled
  const fetchCareerInsightsStatus = useTypedSelector(selectors.fetchCareerInsightsStatus)
  const careerInsightsData = useTypedSelector(selectors.careerInsightsData)
  const isCareerInsightsLoading = fetchCareerInsightsStatus === FetchStatuses.loading

  useEffect(() => {
    if (shouldInit && fetchCareerInsightsStatus === FetchStatuses.notAsked) {
      dispatch(actions.startCareerInsightsPolling())
    }
  }, [shouldInit, fetchCareerInsightsStatus, dispatch])

  return {
    careerInsightsData,
    isCareerInsightsLoading,
  }
}
